import { DialogClose, DialogContent, DialogDescription, DialogTitle } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { overlay } from 'overlay-kit';
import { XSmallCircleColorIcon } from '@/icons';
import { Dialog, DialogOverlay, DialogPortal, IconButton } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
export const ImageDetailModal = ({
  imageSrc,
  onClose,
  isOpen,
  container
}: {
  imageSrc: string;
  onClose: () => void;
  isOpen: boolean;
  container?: HTMLElement | null;
}) => {
  return <Dialog open={isOpen} data-sentry-element="Dialog" data-sentry-component="ImageDetailModal" data-sentry-source-file="ImageDetailModal.tsx">
      <DialogPortal container={container} data-sentry-element="DialogPortal" data-sentry-source-file="ImageDetailModal.tsx">
        <DialogOverlay onClick={onClose} data-sentry-element="DialogOverlay" data-sentry-source-file="ImageDetailModal.tsx" />
        <DialogContent autoFocus={false} className={cn('overflow-hidden rounded-md fixed left-[50%] top-[50%] z-modal w-fit translate-x-[-50%] translate-y-[-50%] shadow-xl bg-white p-0 duration-200', 'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]')} data-sentry-element="DialogContent" data-sentry-source-file="ImageDetailModal.tsx">
          <VisuallyHidden data-sentry-element="VisuallyHidden" data-sentry-source-file="ImageDetailModal.tsx">
            <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="ImageDetailModal.tsx">{'Image Detail'}</DialogTitle>
            <DialogDescription data-sentry-element="DialogDescription" data-sentry-source-file="ImageDetailModal.tsx">
              {'This is the detail of the image'}
            </DialogDescription>
          </VisuallyHidden>
          <img src={imageSrc} alt="detail image" className="h-auto max-h-[90vh] min-h-[200px] min-w-[200px] max-w-[90vw] object-contain" />
          <DialogClose asChild data-sentry-element="DialogClose" data-sentry-source-file="ImageDetailModal.tsx">
            <IconButton className="absolute right-2xs top-2xs" onClick={onClose} size="xs" rounded="full" variant="transparent" intent="neutral" data-sentry-element="IconButton" data-sentry-source-file="ImageDetailModal.tsx">
              <XSmallCircleColorIcon width={28} height={28} data-sentry-element="XSmallCircleColorIcon" data-sentry-source-file="ImageDetailModal.tsx" />
            </IconButton>
          </DialogClose>
        </DialogContent>
      </DialogPortal>
    </Dialog>;
};
export const imageDetailModal = {
  open: (imageSrc: string, container?: HTMLElement | null) => {
    return overlay.open(({
      close,
      isOpen
    }) => {
      return <ImageDetailModal imageSrc={imageSrc} onClose={close} isOpen={isOpen} container={container} />;
    });
  }
};